import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from '@hooks/useLocation';

import { verifyAccessCode } from '@actions/account/accountActionCreators';
import AccessCodePage from './AccessCode';
import { useTitle } from '@hooks/useTitle';

interface IAccessCodeContainerProps {
    environment: {
        exchangeName: string;
        language: string;
        location: {
            pathname: string;
        };
        accessCodeExpandedViewEnabled: boolean;
        hideCaptcha: boolean;
        properties: {
            RECAPTCHA_SITE_KEY: string;
        };
        stateCode: string;
    };
    authentication: boolean;
    actions: {
        verifyAccessCode: typeof verifyAccessCode;
    };
}

const AccessCodeContainer = (props: IAccessCodeContainerProps) => {
    const {
        environment: { exchangeName, language, location },
    } = props;

    const { currentLocation } = useLocation();
    const pathname = location ? location.pathname : currentLocation;

    useTitle('', {
        adjustedFlow: [],
        exchangeName,
        language,
        pathname,
    });

    return (
        <Fragment>
            <main className="usa-layout-docs usa-section gi-main-section" id="access-code__page">
                <div className="grid-container gi-grid-container">
                    <div className="grid-row grid-gap gi-wrapper">
                        <div className="center" id="main-content">
                            <AccessCodePage {...props} />
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    authentication: state.authentication.failure,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            verifyAccessCode,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessCodeContainer);
